import { ZipAnalysisSearchSelections, ZipClassSortableColumnEnum, ZipClassTableData, ZipCodeSortableColumnEnum, ZipCodeTableData, ZipProjectAction, ZipProjectActionsEnum, ZipProjectModuleRoutesEnum } from "./interfaces";
import { DropdownItem } from "@app/shared/checkbox-dropdown";
import { ProjectModule } from "../literals";
import { Project } from "..";
import { ProjectPerspective, ProjectRunConfigurationType } from "../enumerators";
import ProjectRunConfiguration from "../projectRunConfiguration";
import { formatDateTime } from "@app/shared/formatDateTime";
import { wafflesKeyColumnName } from "@app/shared/waffles/exports";

export const createDummyDropdownItem = (value: string): DropdownItem<string> => {
  return {
    display: value,
    key: value,
    name: value,
  };
}

export const onRunProject = (
  dispatch: (value: ZipProjectAction) => void,
  onRunProject: (projectId: number) => void,
  projectId: number
): void => {
  dispatch({
    payload: {},
    type: ZipProjectActionsEnum.Loading,
  });
  onRunProject(projectId);
}

export const translateUrlModuleToProjectModule = (urlModule: ZipProjectModuleRoutesEnum): ProjectModule => {
  let newModule: ProjectModule;
  switch (urlModule.toLowerCase()) {
    case ZipProjectModuleRoutesEnum.Adequacy:
      newModule = "Adequacy";
      break;
    case ZipProjectModuleRoutesEnum.Summary:
      newModule = "Summary";
      break;
    default:
      newModule = "Adequacy";
      break;
  }
  return newModule;
}

export const isProjectRunning = (project: Project): boolean => {
  return !project
    || project.isRunning
    || project.isReadOnly;
}

const getZipCodeSortedColumnFromEnum = (newColumn: string): ZipCodeSortableColumnEnum => {
  let sortedColumn: ZipCodeSortableColumnEnum;
  switch (newColumn) {
    /* zip code */
    case "state":
      sortedColumn = ZipCodeSortableColumnEnum.StateName;
      break;
    case "county":
      sortedColumn = ZipCodeSortableColumnEnum.County;
      break;
    case "city":
      sortedColumn = ZipCodeSortableColumnEnum.City;
      break;
    case "zipClass":
      sortedColumn = ZipCodeSortableColumnEnum.ZipClass;
      break;
    case "zipCode":
      sortedColumn = ZipCodeSortableColumnEnum.ZipCode;
      break;
    case "specialty":
      sortedColumn = ZipCodeSortableColumnEnum.SpecialtyGroupCode;
      break;
    case "minProviderCount":
      sortedColumn = ZipCodeSortableColumnEnum.MinProviderCount;
      break;
    case "reqDist":
      sortedColumn = ZipCodeSortableColumnEnum.ReqDist;
      break;
    case "reqTime":
      sortedColumn = ZipCodeSortableColumnEnum.ReqTime;
      break;
    case "minPassPercent":
      sortedColumn = ZipCodeSortableColumnEnum.MinPassPercent;
      break;
    case "metPassPercent":
      sortedColumn = ZipCodeSortableColumnEnum.MetPassPercent;
      break;
    case "metTime":
      sortedColumn = ZipCodeSortableColumnEnum.MetTime;
      break;
    case "metDist":
      sortedColumn = ZipCodeSortableColumnEnum.MetDist;
      break;
    case "membershipCount":
      sortedColumn = ZipCodeSortableColumnEnum.MembershipCount;
      break;
    case "providerCount":
      sortedColumn = ZipCodeSortableColumnEnum.ProviderCount;
      break;
    case "memberCountWithAccess":
      sortedColumn = ZipCodeSortableColumnEnum.MemberCountWithAccess;
      break;
    case "withAccessPercent":
      sortedColumn = ZipCodeSortableColumnEnum.WithAccessPercent;
      break;
    case "memberCountWithoutAccess":
      sortedColumn = ZipCodeSortableColumnEnum.MemberCountWithoutAccess;
      break;
    case "withoutAccessPercent":
      sortedColumn = ZipCodeSortableColumnEnum.WithoutAccessPercent;
      break;
    case "avgDist":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistance;
      break;
    case "avgTime":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTime;
      break;
    case "maxDist":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistance;
      break;
    case "maxTime":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTime;
      break;
    case "avgDist2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistance2;
      break;
    case "avgDistWith":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistanceWithAccess;
      break;
    case "avgDistWithout":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistanceWithoutAccess;
      break;
    case "maxDist2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistance2;
      break;
    case "maxDistWith":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistanceWithAccess;
      break;
    case "maxDistWithout":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistanceWithoutAccess;
      break;
    case "avgTime2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTime2;
      break;
    case "avgTimeWith":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTimeWithAccess;
      break;
    case "avgTimeWithout":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTimeWithoutAccess;
      break;
    case "maxTime2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTime2;
      break;
    case "maxTimeWith":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTimeWithAccess;
      break;
    case "maxTimeWithout":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTimeWithoutAccess;
      break;
    case "avgDistWith2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistanceWithAccess2;
      break;
    case "avgDistWithout2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageDistanceWithoutAccess2;
      break;
    case "maxDistWith2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistanceWithAccess2;
      break;
    case "maxDistWithout2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumDistanceWithoutAccess2;
      break;
    case "avgTimeWith2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTimeWithAccess2;
      break;
    case "avgTimeWithout2":
      sortedColumn = ZipCodeSortableColumnEnum.AverageTimeWithoutAccess2;
      break;
    case "maxTimeWith2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTimeWithAccess2;
      break;
    case "maxTimeWithout2":
      sortedColumn = ZipCodeSortableColumnEnum.MaximumTimeWithoutAccess2;
      break;
    case "withDistPercent":
      sortedColumn = ZipCodeSortableColumnEnum.WithAccessByDistancePercent;
      break;
    case "withTimePercent":
      sortedColumn = ZipCodeSortableColumnEnum.WithAccessByTimePercent;
      break;
    case "marketAccessPercent":
      sortedColumn = ZipCodeSortableColumnEnum.MarketAccessPercent;
      break;
    case "marketPercent":
      sortedColumn = ZipCodeSortableColumnEnum.MarketPercent;
      break;
    case "marketServicing":
      sortedColumn = ZipCodeSortableColumnEnum.MarketServicing;
      break;
    case "membershipType":
      sortedColumn = ZipCodeSortableColumnEnum.MembershipType;
      break;
  }
  return sortedColumn;
}

const getZipClassSortedColumnFromEnum = (newColumn: string): ZipClassSortableColumnEnum => {
  let sortedColumn: ZipClassSortableColumnEnum;
  switch (newColumn) {
    case "zipClass":
      sortedColumn = ZipClassSortableColumnEnum.ZipClass;
      break;
    case "specialty":
      sortedColumn = ZipClassSortableColumnEnum.SpecialtyGroupCode;
      break;
    case "minProviderCount":
      sortedColumn = ZipClassSortableColumnEnum.MinProviderCount;
      break;
    case "reqDist":
      sortedColumn = ZipClassSortableColumnEnum.ReqDist;
      break;
    case "reqTime":
      sortedColumn = ZipClassSortableColumnEnum.ReqTime;
      break;
    case "minPassPercent":
      sortedColumn = ZipClassSortableColumnEnum.MinPassPercent;
      break;
    case "membershipCount":
      sortedColumn = ZipClassSortableColumnEnum.MembershipCount;
      break;
    case "providerCount":
      sortedColumn = ZipClassSortableColumnEnum.ProviderCount;
      break;
    case "memberCountWith":
      sortedColumn = ZipClassSortableColumnEnum.MemberCountWithAccess;
      break;
    case "withPercent":
      sortedColumn = ZipClassSortableColumnEnum.WithAccessPercent;
      break;
    case "memberCountWithout":
      sortedColumn = ZipClassSortableColumnEnum.MemberCountWithoutAccess;
      break;
    case "withoutPercent":
      sortedColumn = ZipClassSortableColumnEnum.WithoutAccessPercent;
      break;
    case "metOverall":
      sortedColumn = ZipClassSortableColumnEnum.MetOverall;
      break;
    case "avgDist":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistance;
      break;
    case "avgDist2":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistance2;
      break;
    case "avgDistWith":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistanceWithAccess;
      break;
    case "avgDistWithout":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistanceWithoutAccess;
      break;
    case "maxDist":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistance;
      break;
    case "maxDist2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistance2;
      break;
    case "maxDistWith":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistanceWithAccess;
      break;
    case "maxDistWithout":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistanceWithoutAccess;
      break;
    case "avgTime":
      sortedColumn = ZipClassSortableColumnEnum.AverageTime;
      break;
    case "avgTime2":
      sortedColumn = ZipClassSortableColumnEnum.AverageTime2;
      break;
    case "avgTimeWith":
      sortedColumn = ZipClassSortableColumnEnum.AverageTimeWithAccess;
      break;
    case "avgTimeWithout":
      sortedColumn = ZipClassSortableColumnEnum.AverageTimeWithoutAccess;
      break;
    case "maxTime":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTime;
      break;
    case "maxTime2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTime2;
      break;
    case "maxTimeWith":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTimeWithAccess;
      break;
    case "maxTimeWithout":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTimeWithoutAccess;
      break;
    case "avgDistWith2":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistanceWithAccess2;
      break;
    case "avgDistWithout2":
      sortedColumn = ZipClassSortableColumnEnum.AverageDistanceWithoutAccess2;
      break;
    case "maxDistWith2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistanceWithAccess2;
      break;
    case "maxDistWithout2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumDistanceWithoutAccess2;
      break;
    case "avgTimeWith2":
      sortedColumn = ZipClassSortableColumnEnum.AverageTimeWithAccess2;
      break;
    case "avgTimeWithout2":
      sortedColumn = ZipClassSortableColumnEnum.AverageTimeWithoutAccess2;
      break;
    case "maxTimeWith2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTimeWithAccess2;
      break;
    case "maxTimeWithout2":
      sortedColumn = ZipClassSortableColumnEnum.MaximumTimeWithoutAccess2;
      break;
    case "withDistPercent":
      sortedColumn = ZipClassSortableColumnEnum.WithAccessByDistancePercent;
      break;
    case "withTimePercent":
      sortedColumn = ZipClassSortableColumnEnum.WithAccessByTimePercent;
      break;
    case "marketAccessPercent":
      sortedColumn = ZipClassSortableColumnEnum.MarketAccessPercent;
      break;
    case "marketPercent":
      sortedColumn = ZipClassSortableColumnEnum.MarketPercent;
      break;
    case "marketServicing":
      sortedColumn = ZipClassSortableColumnEnum.MarketServicing;
      break;
    case "membershipType":
      sortedColumn = ZipClassSortableColumnEnum.MembershipType;
      break;
  }
  return sortedColumn;
}

export const getSortedColumnFromEnum = (newColumn: string, perspective: ProjectPerspective): ZipCodeSortableColumnEnum | ZipClassSortableColumnEnum => {
  switch (perspective) {
    case ProjectPerspective.ByZipClass:
      return getZipClassSortedColumnFromEnum(newColumn);
    case ProjectPerspective.ByZipCode:
      return getZipCodeSortedColumnFromEnum(newColumn);
  }
}

export const printNumericString = (value: number): string => {
  return value !== undefined ? value.toFixed(1).toLocaleString() : "---";
}

export const printPercentString = (value: number): string => {
  return value !== undefined ? `${value.toFixed(1)}` : "---";
}

export const getTimeString = (runConfiguration: ProjectRunConfiguration): string => {
  return runConfiguration.isLatestPublished
    ? `Latest Published (${formatDateTime(runConfiguration.dateCreated)})`
    : runConfiguration.isProjected ? "Projected"
      : runConfiguration.isProjectedTermed ? "Projected-Termed"
        : runConfiguration.isTermed ? "Termed"
          : !runConfiguration.datePublished ? `Unpublished (${formatDateTime(runConfiguration.dateCreated)})`
            : formatDateTime(runConfiguration.dateCreated);
}

export const blankZipCodeRow: ZipCodeTableData = {
  accessTelehealthCredit: "---",
  avgDist: "---",
  avgDist2: "---",
  avgDistWith: "---",
  avgDistWith2: "---",
  avgDistWithout: "---",
  avgDistWithout2: "---",
  avgTime: "---",
  avgTime2: "---",
  avgTimeWith: "---",
  avgTimeWith2: "---",
  avgTimeWithout: "---",
  avgTimeWithout2: "---",
  city: "---",
  county: "---",
  isInformationalSpecialty: false,
  marketAccessPercent: "---",
  marketPercent: "---",
  marketServicing: "---",
  maxDist: "---",
  maxDist2: "---",
  maxDistWith: "---",
  maxDistWith2: "---",
  maxDistWithout: "---",
  maxDistWithout2: "---",
  maxTime: "---",
  maxTime2: "---",
  maxTimeWith: "---",
  maxTimeWith2: "---",
  maxTimeWithout: "---",
  maxTimeWithout2: "---",
  memberCountWithAccess: "---",
  memberCountWithoutAccess: "---",
  membershipCount: "---",
  membershipType: "---",
  metDist: "---",
  metPassPercent: "---",
  metTime: "---",
  minPassPercent: "---",
  minProviderCount: "---",
  providerCount: "---",
  reqDist: "---",
  reqTime: "---",
  resultsFor: "---",
  specialty: "---",
  state: "---",
  [wafflesKeyColumnName]: null,
  withAccessPercent: "---",
  withDistPercent: "---",
  withTimePercent: "---",
  withoutAccessPercent: "---",
  zipClass: "---",
  zipCode: undefined,
};

export const blankZipClassRow: ZipClassTableData = {
  accessTelehealthCredit: "---",
  avgDist: "---",
  avgDist2: "---",
  avgDistWith: "---",
  avgDistWith2: "---",
  avgDistWithout: "---",
  avgDistWithout2: "---",
  avgTime: "---",
  avgTime2: "---",
  avgTimeWith: "---",
  avgTimeWith2: "---",
  avgTimeWithout: "---",
  avgTimeWithout2: "---",
  isInformationalSpecialty: false,
  marketAccessPercent: "---",
  marketPercent: "---",
  marketServicing: "---",
  maxDist: "---",
  maxDist2: "---",
  maxDistWith: "---",
  maxDistWith2: "---",
  maxDistWithout: "---",
  maxDistWithout2: "---",
  maxTime: "---",
  maxTime2: "---",
  maxTimeWith: "---",
  maxTimeWith2: "---",
  maxTimeWithout: "---",
  maxTimeWithout2: "---",
  memberCountWith: "---",
  memberCountWithout: "---",
  membershipCount: "---",
  membershipType: "---",
  metDist: "---",
  metOverall: "---",
  metTime: "---",
  minPassPercent: "---",
  minProviderCount: "---",
  providerCount: "---",
  reqDist: "---",
  reqTime: "---",
  resultsFor: "---",
  specialty: "---",
  [wafflesKeyColumnName]: null,
  withDistPercent: "---",
  withPercent: "---",
  withTimePercent: "---",
  withoutPercent: "---",
  zipClass: "---",
}

/**
 * A function to take two sets of data and, if there are any key discrepancies (e.g. the service area changed between runs),
 * it will fill in that key with a blank row for presentation purposes.
 */
export const fillInMissingCompareModeRows = <T extends ZipCodeTableData | ZipClassTableData,>(records1: T[], records2: T[], blankRecord: T, timestamp1: string, timestamp2: string): [T[], T[]] => {
  if (!records1 || !records2) {
    return [records1, records2];
  }

  const newRecords1 = [...records1];
  const newRecords2 = [...records2];
  const keys1 = records1.map((r) => r[wafflesKeyColumnName]);
  const keys2 = records2.map((r) => r[wafflesKeyColumnName]);
  const exclusiveKeys1 = keys1.filter((k) => !keys2.includes(k));
  const exclusiveKeys2 = keys2.filter((k) => !keys1.includes(k));

  exclusiveKeys1.forEach((k) => {
    const newBlank = { ...blankRecord, resultsFor: timestamp2, [wafflesKeyColumnName]: k, };
    newRecords2.push(newBlank);
  })

  exclusiveKeys2.forEach((k) => {
    const newBlank = { ...blankRecord, [wafflesKeyColumnName]: k };
    const matchingRecord = records2.find((r) => r.key === k) as ZipCodeTableData;
    if (newRecords1.length === 0 || !!(newRecords1[0] as ZipCodeTableData).zipCode) {
      const newZipCodeBlank: ZipCodeTableData = {
        ...newBlank as ZipCodeTableData,
        city: matchingRecord.city,
        county: matchingRecord.county,
        resultsFor: timestamp1,
        specialty: matchingRecord.specialty,
        state: matchingRecord.state,
        zipClass: matchingRecord.zipClass,
        zipCode: matchingRecord.zipCode,
      };
      newRecords1.push(newZipCodeBlank as T);
    } else {
      const newZipClassBlank: ZipClassTableData = {
        ...newBlank as ZipClassTableData,
        resultsFor: timestamp1,
        specialty: matchingRecord.specialty,
        zipClass: matchingRecord.zipClass,
      };
      newRecords1.push(newZipClassBlank as T);
    }
  })

  return [newRecords1, newRecords2];
}

// The top configuration is the older of the two in compare mode, or the primary membership in dual membership
// The bottom configuration is the newer of the two in compare mode, or the secondary membership in dual membership
export const getTopAndBottomRunConfigurations = (
  runConfig1: ProjectRunConfiguration,
   runConfig2: ProjectRunConfiguration,
    isCompareMode: boolean, 
    isDualMembershipMode: boolean,
  ): { bottomConfig: ProjectRunConfiguration, topConfig: ProjectRunConfiguration } => {
  let topConfig, bottomConfig;
  if (!isCompareMode && !isDualMembershipMode) {
    return { bottomConfig: undefined, topConfig: runConfig1 };
  }
  if (isCompareMode) {
    if (runConfig1.dateCreated > runConfig2.dateCreated) {
      topConfig = runConfig2;
      bottomConfig = runConfig1;
    } else {
      topConfig = runConfig1;
      bottomConfig = runConfig2;
    }
  } else if (isDualMembershipMode) {
    // the API is expected to always return the primary membership config as item 0, and the secondary as item 1
    topConfig = runConfig1;
    bottomConfig = runConfig2;
  }

  return { bottomConfig, topConfig: topConfig };
}

export const haveFilterSelectionsChanged = (filterSelections1: ZipAnalysisSearchSelections, filterSelections2: ZipAnalysisSearchSelections): boolean => {
  return (
    filterSelections1.city !== filterSelections2.city
    || filterSelections1.county.key !== filterSelections2.county.key
    || filterSelections1.metOverall.key !== filterSelections2.metOverall.key
    || filterSelections1.metPassPercent.key !== filterSelections2.metPassPercent.key
    || filterSelections1.specialtyGroupCode.key !== filterSelections2.specialtyGroupCode.key
    || filterSelections1.state.key !== filterSelections2.state.key
    || filterSelections1.zipClass.key !== filterSelections2.zipClass.key
    || filterSelections1.zipCode !== filterSelections2.zipCode
  );
}

// if we're in single membership mode, but the second membership is the one selected, we want to use the "compared" details instead
export const shouldUseComparedZipDetails = (isDualMembership: boolean, isCompareMode: boolean, zipDetailsComparedLength: number, topConfigType: ProjectRunConfigurationType): boolean => {
  return !isDualMembership && !isCompareMode && zipDetailsComparedLength > 0 && topConfigType === ProjectRunConfigurationType.DualMembershipSupplemental;
}
